import { FaIconPlugin, ICONS, type FaIcons } from './FontAwesome';
import sentry from './sentry';

export { ICONS, type FaIcons };
export default [FaIconPlugin, sentry];
